import { render, staticRenderFns } from "./BeneficioConcedente.vue?vue&type=template&id=c09e3ca2"
import script from "./BeneficioConcedente.vue?vue&type=script&lang=js"
export * from "./BeneficioConcedente.vue?vue&type=script&lang=js"
import style0 from "./BeneficioConcedente.vue?vue&type=style&index=0&id=c09e3ca2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports